/* Progressive enhancement only: Shopify Liquid owns success and error states. */
if (!customElements.get('tb-aftercare')) {
  customElements.define('tb-aftercare', class extends HTMLElement {
    connectedCallback() {
      if (this.feedbackFocused || window.Shopify?.designMode) return;
      if (!this.querySelector('[data-aftercare-feedback]')) return;
      // Native contact navigation targets the form fragment. Focus afterwards,
      // otherwise the browser's initial fragment navigation clears the feedback focus.
      this.onReady = () => {
        this.focusFrame = requestAnimationFrame(() => {
          if (!this.isConnected || this.feedbackFocused || window.Shopify?.designMode) return;
          const feedback = this.querySelector('[data-aftercare-feedback]');
          if (!feedback) return;
          this.feedbackFocused = true;
          feedback.focus();
        });
      };
      if (document.readyState === 'complete') this.onReady();
      else window.addEventListener('load', this.onReady, { once: true });
    }

    disconnectedCallback() {
      window.removeEventListener('load', this.onReady);
      cancelAnimationFrame(this.focusFrame);
    }
  });
}
